import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { FormsModule } from '@angular/forms';
import { TranslatePipe, TranslateDirective } from '@ngx-translate/core';
import { VivaDateInputModule } from '../controls/viva-date-input/viva-date-input.module';
import { PopupModule } from '../controls/pop-up/popup.module';
import { PatientFullNamePipe } from '../pipes/patient.pipe';
import { UsPhoneFormatPipe } from '../pipes/us-phone-format.pipe';
import { PermissionOverlayDirective } from './directives/permission-overlay.directive';
import { UsPhoneFormatDirective } from './directives/us-phone-format.directive';
import { BarGuageModule } from '../controls/bar-guage/bar-guage.module';

@NgModule({
	declarations: [PatientFullNamePipe, UsPhoneFormatPipe, PermissionOverlayDirective, UsPhoneFormatDirective],
	imports: [
		CommonModule,
		RouterModule,
		IonicModule,
		FormsModule,
		TranslatePipe, TranslateDirective,
		VivaDateInputModule,
		PopupModule,
		BarGuageModule
	],
	exports: [
		FormsModule,
		TranslatePipe, TranslateDirective,
		VivaDateInputModule,
		PopupModule,
		PatientFullNamePipe,
		UsPhoneFormatPipe,
		PermissionOverlayDirective,
		UsPhoneFormatDirective,
		BarGuageModule
	],
})
export class SharedModule { }